import { UserDto } from '../models/dto';
import { getFeatureFlagsPropsForAnalytics, UserAnalyticsFeatureFlagsDto } from '.';

type UserFieldsToIncludeIntoAnalytics = Partial<Pick<UserDto, 'genderId'
	| 'customGender'
	| 'dateOfBirth'
	|	'createdAt'
	|	'lastLoginAt'
	|	'homeAddressCityId'
	|	'homeAddressStateId'
	|	'homeAddressCountryId'
	|	'homeAddressName'
  | 'fullName'
  | 'userName'
  | 'login'
  | 'receiptsEmail'>>;

export type UserAnalyticsDto = UserFieldsToIncludeIntoAnalytics
	& {
		user_id?: string;
	}
	& {
		feature_flags?: UserAnalyticsFeatureFlagsDto;
	};

export const userPropsIncludedIntoAnalytics: Array<keyof UserFieldsToIncludeIntoAnalytics> = [
	'genderId',
	'customGender',
	'dateOfBirth',
	'createdAt',
	'lastLoginAt',
	'homeAddressCityId',
	'homeAddressStateId',
	'homeAddressCountryId',
	'homeAddressName',
	'fullName',
	'userName',
	'login',
	'receiptsEmail'
];

export const getUserDataToWriteIntoAnalytics = (user?: UserDto): UserAnalyticsDto => {
	if (!user) {
		return {};
	}
	const result: UserAnalyticsDto = {
		user_id: user.id
	};

	for (const includedProperty of userPropsIncludedIntoAnalytics) {
		if (!(includedProperty in user)) {
			continue;
		}

		if (user[includedProperty] === null || user[includedProperty] === undefined) {
			continue;
		}

		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		result[includedProperty] = user[includedProperty] as unknown as any;
	}

	result.feature_flags = getFeatureFlagsPropsForAnalytics(user);

	return result;
}
